import { createReducer } from '@reduxjs/toolkit';

import defaultState from './defaultState';
import { reducer as listProductTypesReducer } from './list';
import { reducer as createProductTypeReducer } from './create';
import { reducer as renameProductTypeReducer } from './rename';
import { reducer as deleteProductTypeReducer } from './delete';

const productTypesReducer = createReducer(
  defaultState,
  (builder) => {
    listProductTypesReducer(builder);
    createProductTypeReducer(builder);
    renameProductTypeReducer(builder);
    deleteProductTypeReducer(builder);
  },
);

export default productTypesReducer;
